export const path = '/glp-won/:gameId/phone-number';
export const component = 'PhoneNumber';
